import type { IconData } from '@stacksjs/iconify-core'

export const fullscreen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M208 48V16H16v192h32V70.627l160.687 160.686l22.626-22.626L70.627 48zm256 256v137.373L299.313 276.687l-22.626 22.626L441.373 464H304v32h192V304z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default fullscreen
